"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { cn } from '../helpers/cn.mjs';
import { forwardRef } from 'react';

const SKELETON_CLASSES = "animate-pulse bg-clip-padding bg-gray-a4 rounded-md text-transparent cursor-default pointer-events-none select-none [&::before]:invisible [&::after]:invisible [&_*]:invisible";
const Skeleton = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn(SKELETON_CLASSES, className), ...props }));
Skeleton.displayName = "Skeleton";

export { Skeleton };
